import React, { Component } from 'react'
import {SaveUserToDB, SaveContainerToDB, SaveScanListToDB } from '../utils/util-networkCalls.js';

class MonitorContainer extends Component {
  constructor(props){
    super(props);
  }

  saveLogic = async ()=> {
    let userId = ''
    let userResponse = await SaveUserToDB(this.props.authState)
    .then( response =>{
        userId = response.userId;
        console.log(response);
    });

    let containerResponse = await SaveContainerToDB(this.props.containerObject, this.props.authState, userId)
    .then( response =>{
        console.log(response);
    });

    let scanListResponse = await SaveScanListToDB(this.props.containerObject.publicId, this.props.liveVersion.containerVersionId)
    .then( response =>{
        console.log(response);
    });
  }
  render() {

    if(this.props.containerObject){

      return (
        <div>
          <button type="button" onClick={this.saveLogic}>Save Preferences to API</button>
        </div>
     )
    } else{
      return(null)
    }
  }
}

export default MonitorContainer;
